import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=1843fe5b&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=ts&"
export * from "./jianyi.vue?vue&type=script&lang=ts&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=1843fe5b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1843fe5b",
  null
  
)

export default component.exports